import getString from '@/helpers/GetStrings';

export default {
  data() {
    return {
      dataLoaded: false,
      data: {},
      config: {},
    };
  },
  created() {
    if (this.$route.params.id && this.$route.params.id !== 'add') {
      // Fetch the selected module details by id.
      this.axios.get(`/${this.endpoint}/${this.$route.params.id}`)
        .then((response) => {
          // In the module detail page, if a given id is not found, we will always get a 200 OK response.
          if (!response.data[this.responseData.single]) {
          // Redirect to modules overview
            this.$router.push(`/${this.module}`);
            return;
          }
          this.data = response.data[this.responseData.single];
          this.config.data = this.data;
          this.dataLoaded = true;
        })
        .catch((error) => {
          console.warn(error);

          // Notify if nothing found
          if (error.response.status === 404) {
            this.$q.notify({
              message: getString(`module.${this.module}.edit.error.nothingFound`),
              type: 'warning',
              timeout: 2000,
              position: 'top-right',
            });
          } else {
          // Throw general error notification
            this.$q.notify({
              message: getString('error.general'),
              position: 'top-right',
              timeout: 1000,
              type: 'warning',
            });
          }

          // Redirect to modules overview
          this.$router.push(`/${this.module}`);
        });
    } else {
      // Nothing to load
      this.dataLoaded = true;
    }
  },
};
